/**
 * Returns the current date in the format of YYYY-MM-DD
 */
export const getTodaysDateSeed = () => new Date().toISOString().split('T')[0]
